import { AnimatedBar } from './animated-bar'

const ISPS = [
  { label: 'Gmail', rate: 98.5, color: '#22c55e' },
  { label: 'Outlook', rate: 97.2, color: '#3b82f6' },
  { label: 'Yahoo', rate: 96.8, color: '#a855f7' },
  { label: 'iCloud', rate: 99.1, color: '#FF6B00' },
] as const

export function DeliveryBars() {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
      {ISPS.map((isp, i) => (
        <div key={i}>
          <div
            style={{
              display: 'flex', justifyContent: 'space-between',
              marginBottom: 6, alignItems: 'baseline',
            }}
          >
            <span style={{ fontSize: 14, fontWeight: 600, color: '#1a1216' }}>
              {isp.label}
            </span>
            <span
              style={{
                fontSize: 13, fontWeight: 700, color: isp.color,
                fontFamily: "var(--oe-font-mono)",
              }}
            >
              {isp.rate}%
            </span>
          </div>
          <AnimatedBar width={isp.rate} color={isp.color} delay={i * 200} />
        </div>
      ))}
      <div
        style={{
          marginTop: 8, padding: '12px 16px', background: '#f8f7f5',
          borderRadius: 10, fontSize: 12, color: '#6d6462', lineHeight: 1.5,
        }}
      >
        Real ISP-level breakdown in your dashboard. Not a vanity number — actual
        delivery data per provider.
      </div>
    </div>
  )
}
